import { render } from "./AddonViewFullText.vue?vue&type=template&id=60af4868&scoped=true&ts=true"
import script from "./AddonViewFullText.vue?vue&type=script&lang=ts"
export * from "./AddonViewFullText.vue?vue&type=script&lang=ts"

import "./AddonViewFullText.vue?vue&type=style&index=0&id=60af4868&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60af4868"]])

export default __exports__